<template>
    <div class="algolia-autocomplete" v-show="isSearching">
        <ul role="listbox">
            <li v-for="result in results">
                <a :href="result.path">
                    {{ result.name }}
                    <span style="color: grey; font-weight: 400;" v-if="result.regions.length && ! result.elearning">
                        ({{ result.regions[0].name }})
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import { Component } from 'vue-instantsearch';

    export default {
        mixins: [Component],

        computed: {
            isSearching() {
                return this.searchStore.query.trim().length !== 0;
            },
            query() {
                return this.searchStore.query;
            },
            results() {
                return this.searchStore.results.slice(0, 10);
            }
        }
    }
</script>
